"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[26852],{

/***/ 66278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export Footer */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);



function Footer(param) {
    var children = param.children, previous = param.previous, next = param.next;
    return /*#__PURE__*/ _jsxs("footer", {
        className: clsx("text-sm leading-6", previous || next ? "mt-12" : "mt-16"),
        children: [
            (previous || next) && /*#__PURE__*/ _jsxs("div", {
                className: "mb-10 text-gray-700 font-semibold flex items-center",
                children: [
                    previous && /*#__PURE__*/ _jsx(Link, {
                        href: previous.href,
                        children: /*#__PURE__*/ _jsxs("a", {
                            className: "group flex items-center hover:text-gray-900",
                            children: [
                                /*#__PURE__*/ _jsx("svg", {
                                    viewBox: "0 0 3 6",
                                    className: "mr-3 w-auto h-1.5 text-gray-400 overflow-visible group-hover:text-gray-600",
                                    children: /*#__PURE__*/ _jsx("path", {
                                        d: "M3 0L0 3L3 6",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                }),
                                previous.shortTitle || previous.title
                            ]
                        })
                    }),
                    next && /*#__PURE__*/ _jsx(Link, {
                        href: next.href,
                        children: /*#__PURE__*/ _jsxs("a", {
                            className: "group ml-auto flex items-center hover:text-gray-900",
                            children: [
                                next.shortTitle || next.title,
                                /*#__PURE__*/ _jsx("svg", {
                                    viewBox: "0 0 3 6",
                                    className: "ml-3 w-auto h-1.5 text-gray-400 overflow-visible group-hover:text-gray-600",
                                    children: /*#__PURE__*/ _jsx("path", {
                                        d: "M0 0L3 3L0 6",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "pt-10 pb-28 border-t border-gray-200 sm:flex justify-between text-gray-500",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "mb-6 sm:mb-0 sm:flex",
                    children: /*#__PURE__*/ _jsxs("p", {
                        children: [
                            "Copyright \xa9 ",
                            new Date().getFullYear(),
                            " Tradly Platform."
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 67129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;


/***/ }),

/***/ 21744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ SidebarLayout; },
/* harmony export */   "l": function() { return /* binding */ SidebarContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67129);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var _components_Search__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30112);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85220);
/* harmony import */ var _partials_TradlyFooter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48777);











var SidebarContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.createContext)();
var NavItem = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(function(param, ref) {
    var href = param.href, children = param.children, isActive = param.isActive, isPublished = param.isPublished, fallbackHref = param.fallbackHref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        ref: ref,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: isPublished ? href : fallbackHref,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("block border-l-2 pl-4 -ml-px py-1", {
                    "text-color10 bg-lightYellow border-[#FFCA1E] font-semibold": isActive,
                    "border-transparent hover:border-[#FFCA1E] hover:bg-lightYellow": !isActive,
                    "text-gray-700 hover:text-gray-900": !isActive && isPublished,
                    "text-gray-400": !isActive && !isPublished
                }),
                children: children
            })
        })
    });
});
/**
 * Find the nearst scrollable ancestor (or self if scrollable)
 *
 * Code adapted and simplified from the smoothscroll polyfill
 *
 *
 * @param {Element} el
 */ function nearestScrollableContainer(el) {
    var isScrollable = /**
   * indicates if an element can be scrolled
   *
   * @param {Node} el
   */ function isScrollable(el) {
        if (!window || !el) {
            window.location.reload();
            return false;
        }
        var style = window.getComputedStyle(el);
        var overflowX = style["overflowX"];
        var overflowY = style["overflowY"];
        var canScrollY = el.clientHeight < el.scrollHeight;
        var canScrollX = el.clientWidth < el.scrollWidth;
        var isScrollableY = canScrollY && (overflowY === "auto" || overflowY === "scroll");
        var isScrollableX = canScrollX && (overflowX === "auto" || overflowX === "scroll");
        return isScrollableY || isScrollableX;
    };
    while(el !== document.body && isScrollable(el) === false){
        el = (el === null || el === void 0 ? void 0 : el.parentNode) || (el === null || el === void 0 ? void 0 : el.host);
    }
    return el;
}
function Nav(param) {
    var nav = param.nav, children = param.children, fallbackHref = param.fallbackHref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var activeItemRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
    var previousActiveItemRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
    var scrollRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
    (0,_hooks_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_4__/* .useIsomorphicLayoutEffect */ .L)(function() {
        var updatePreviousRef = function updatePreviousRef() {
            previousActiveItemRef.current = activeItemRef.current;
        };
        if (activeItemRef.current) {
            if (activeItemRef.current === previousActiveItemRef.current) {
                updatePreviousRef();
                return;
            }
            updatePreviousRef();
            var scrollable = nearestScrollableContainer(scrollRef.current);
            var scrollRect = scrollable.getBoundingClientRect();
            var activeItemRect = activeItemRef.current.getBoundingClientRect();
            var top = activeItemRef.current.offsetTop;
            var bottom = top - scrollRect.height + activeItemRect.height;
            if (scrollable.scrollTop > top || scrollable.scrollTop < bottom) {
                scrollable.scrollTop = top - scrollRect.height / 2 + activeItemRect.height / 2;
            }
        }
    }, [
        router.pathname
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
        ref: scrollRef,
        id: "nav",
        className: "lg:text-sm lg:leading-6",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Search__WEBPACK_IMPORTED_MODULE_5__/* .SearchButton */ .Q, {
                className: "hidden w-full mb-8 lg:flex items-center text-sm leading-6 text-gray-400 rounded-md ring-1 ring-gray-900/10 shadow-sm py-1.5 pl-2 pr-3 hover:ring-gray-300",
                children: function(param) {
                    var actionKey = param.actionKey;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                width: "24",
                                height: "24",
                                fill: "none",
                                "aria-hidden": "true",
                                className: "mr-3 flex-none",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "m19 19-3.5-3.5",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                        cx: "11",
                                        cy: "11",
                                        r: "6",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                ]
                            }),
                            "Quick search...",
                            actionKey && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "ml-auto pl-3 flex-none text-xs font-semibold",
                                children: [
                                    actionKey[0],
                                    "K"
                                ]
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TopLevelNav, {}),
                    children,
                    nav && Object.keys(nav).map(function(category) {
                        var publishedItems = nav[category].filter(function(item) {
                            return (item === null || item === void 0 ? void 0 : item.published) !== false;
                        });
                        if (publishedItems.length === 0 && !fallbackHref) return null;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: "mt-12 lg:mt-8",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("mb-8 lg:mb-3 font-semibold", {
                                        "text-gray-900": publishedItems.length > 0,
                                        "text-gray-400": publishedItems.length === 0
                                    }),
                                    children: category
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                    className: " border-l border-gray-100",
                                    children: (fallbackHref ? nav[category] : publishedItems).map(function(item, i) {
                                        var isActive = (item === null || item === void 0 ? void 0 : item.match) ? item.match.test(router.pathname) : (item === null || item === void 0 ? void 0 : item.href) === router.pathname;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavItem, {
                                            href: item === null || item === void 0 ? void 0 : item.href,
                                            isActive: isActive,
                                            ref: isActive ? activeItemRef : undefined,
                                            isPublished: (item === null || item === void 0 ? void 0 : item.published) !== false,
                                            fallbackHref: fallbackHref,
                                            children: (item === null || item === void 0 ? void 0 : item.shortTitle) || (item === null || item === void 0 ? void 0 : item.title)
                                        }, i);
                                    })
                                })
                            ]
                        }, category);
                    }).filter(Boolean)
                ]
            })
        ]
    });
}
var TopLevelAnchor = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(function(param, ref) {
    var children = param.children, href = param.href, className = param.className, icon = param.icon, isActive = param.isActive, onClick = param.onClick, shadow = param.shadow;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            ref: ref,
            href: href,
            onClick: onClick,
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("group flex items-center lg:text-sm lg:leading-6", className, isActive ? "font-semibold text-color10" : "font-medium text-gray-700 hover:text-gray-900"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("mr-4 rounded-md ring-1 ring-gray-900/5 shadow-sm group-hover:shadow group-hover:ring-gray-900/10", shadow),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        className: "h-6 w-6",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        children: icon
                    })
                }),
                children
            ]
        })
    });
});
function TopLevelLink(_param) {
    var href = _param.href, as = _param.as, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "href",
        "as"
    ]);
    if (/^https?:\/\//.test(href)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TopLevelAnchor, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            href: href
        }, props));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        as: as,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TopLevelAnchor, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props))
    });
}
function TopLevelNav() {
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().pathname;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TopLevelLink, {
                href: "/docs/setup",
                isActive: pathname.startsWith("/docs"),
                className: "mb-4",
                shadow: "group-hover:shadow-sky-200",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M8.5 7c1.093 0 2.117.27 3 .743V17a6.345 6.345 0 0 0-3-.743c-1.093 0-2.617.27-3.5.743V7.743C5.883 7.27 7.407 7 8.5 7Z",
                            className: "fill-sky-200 group-hover:fill-sky-500"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M15.5 7c1.093 0 2.617.27 3.5.743V17c-.883-.473-2.407-.743-3.5-.743s-2.117.27-3 .743V7.743a6.344 6.344 0 0 1 3-.743Z",
                            className: "fill-sky-400 group-hover:fill-sky-500"
                        })
                    ]
                }),
                children: "Documentation"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TopLevelLink, {
                href: "/tutorials",
                className: "mb-4",
                shadow: "group-hover:shadow-pink-200",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z",
                            className: "fill-pink-400 group-hover:fill-pink-500"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M11.082 9.107a.685.685 0 0 0-.72-.01.757.757 0 0 0-.362.653v4.5c0 .27.138.52.362.653.224.133.5.13.72-.01l3.571-2.25A.758.758 0 0 0 15 12a.758.758 0 0 0-.347-.643l-3.571-2.25Z",
                            className: "fill-pink-50 group-hover:fill-pink-100"
                        })
                    ]
                }),
                children: "Video Tutorials"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TopLevelLink, {
                href: "https://developer.tradly.app",
                className: "mb-4",
                shadow: "group-hover:shadow-blue-200",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M4 12a7 7 0 0 1 7-7h2a7 7 0 1 1 0 14h-2a7 7 0 0 1-7-7Z",
                            className: "fill-blue-400 group-hover:fill-blue-500"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M10.25 9.75 7.75 12l2.5 2.25",
                            strokeWidth: "1.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            className: "stroke-blue-50"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "m13.75 9.75 2.5 2.25-2.5 2.25",
                            strokeWidth: "1.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            className: "stroke-blue-200"
                        })
                    ]
                }),
                children: "API References"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TopLevelLink, {
                href: "https://community.tradly.app",
                className: "mb-8",
                shadow: "group-hover:shadow-violet-200",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M11 5a6 6 0 0 0-4.687 9.746c.215.27.315.62.231.954l-.514 2.058a1 1 0 0 0 1.485 1.1l2.848-1.71c.174-.104.374-.15.576-.148H13a6 6 0 0 0 0-12h-2Z",
                            className: "fill-violet-400 group-hover:fill-violet-500"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "12",
                            cy: "11",
                            r: "1",
                            fill: "#fff"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "9",
                            cy: "11",
                            r: "1",
                            fill: "#ddd6fe"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "15",
                            cy: "11",
                            r: "1",
                            fill: "#ddd6fe"
                        })
                    ]
                }),
                children: "Community"
            })
        ]
    });
}
function Wrapper(param) {
    var allowOverflow = param.allowOverflow, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: allowOverflow ? undefined : "overflow-hidden",
        children: children
    });
}
function SidebarLayout(param) {
    var children = param.children, navIsOpen = param.navIsOpen, setNavIsOpen = param.setNavIsOpen, nav = param.nav, sidebar = param.sidebar, fallbackHref = param.fallbackHref, tmp = param.layoutProps, ref = tmp === void 0 ? {} : tmp, _allowOverflow = ref.allowOverflow, allowOverflow = _allowOverflow === void 0 ? true : _allowOverflow;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SidebarContext.Provider, {
        value: {
            nav: nav,
            navIsOpen: navIsOpen,
            setNavIsOpen: setNavIsOpen
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
                allowOverflow: allowOverflow,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-8xl md:flex md:gap-3 mx-auto px-4 xl:px-0 ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: " flex-none hidden md:block sticky z-20 inset-0 w-[17.5rem] py-8 px-4 max-h-screen overflow-y-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Nav, {
                                    nav: nav,
                                    fallbackHref: fallbackHref,
                                    children: sidebar
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: " md:flex-grow md:pt-0",
                                children: children
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: " ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_TradlyFooter__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_10__/* .Dialog */ .V, {
                as: "div",
                open: navIsOpen,
                onClose: function() {
                    return setNavIsOpen(false);
                },
                className: "fixed z-50 inset-0 overflow-y-auto lg:hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_10__/* .Dialog.Overlay */ .V.Overlay, {
                        className: "fixed inset-0 bg-black/20 backdrop-blur-sm"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative bg-white w-80 max-w-[calc(100%-3rem)] p-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                type: "button",
                                onClick: function() {
                                    return setNavIsOpen(false);
                                },
                                className: "absolute top-5 right-5 w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-600",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "sr-only",
                                        children: "Close navigation"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                        viewBox: "0 0 10 10",
                                        className: "w-2.5 h-2.5 overflow-visible",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M0 0L10 10M10 0L0 10",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Nav, {
                                nav: nav,
                                fallbackHref: fallbackHref,
                                children: sidebar
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ })

}]);